"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
function CategoryGrid() {
  const {
    terms,
    loading,
    error,
    refetch
  } = useEcommerceTerms();
  if (loading) {
    return <div data-section-id="224554" className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:gap-6">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="min-h-[400px] animate-pulse rounded-3xl bg-primary/10 lg:min-h-[500px]" />)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="mb-4 text-muted-foreground font-default">
          Failed to load our toy collections.
        </p>
        <button onClick={refetch} className="text-sm font-medium text-accent-foreground hover:underline font-default">
          Try Again
        </button>
      </div>;
  }
  if (!terms || terms.length === 0) {
    return <div className="py-12 text-center text-muted-foreground font-default">
        Our little toy boxes are empty at the moment.
      </div>;
  }
  const displayTerms = terms.slice(0, 4);
  return <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:gap-6">
      {displayTerms.map((term, i) => {
      const isTall = i === 0 || i === 3;
      const pastelColors = ["bg-primary/30", "bg-secondary/40", "bg-accent/20", "bg-chart-4/30"];
      return <Link to={term.link || "#"} key={term.id} data-index={i} className={`group relative flex flex-col justify-end overflow-hidden rounded-3xl shadow-md transition-all duration-500 hover:shadow-xl ${pastelColors[i % pastelColors.length]} ${isTall ? "min-h-[450px] lg:min-h-[600px]" : "min-h-[400px] lg:min-h-[500px]"}`}>
            {}
            <div className="absolute inset-0 overflow-hidden">
              <img src={term.image_url || `/img/generic_tech_category_${i + 1}.png`} alt={term.name} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" loading="lazy" />
            </div>

            {}
            <div className="absolute inset-0 bg-gradient-to-t from-primary/60 via-background/10 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-100" />

            {}
            <div className="relative z-10 flex items-end justify-between p-6 md:p-8 lg:p-10">
              <div className="max-w-[80%]">
                <h3 className="font-default text-3xl font-bold uppercase tracking-widest text-foreground md:text-4xl lg:text-5xl">
                  {term.name}
                </h3>
                {term.description && <p className="mt-2 line-clamp-2 text-sm font-default text-foreground/80 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    {term.description}
                  </p>}
              </div>

              {}
              <div className="flex h-14 w-14 shrink-0 translate-x-4 items-center justify-center rounded-full bg-background/80 text-accent-foreground shadow-sm opacity-0 backdrop-blur-md transition-all duration-300 ease-out group-hover:translate-x-0 group-hover:opacity-100">
                <ArrowRight className="h-7 w-7" />
              </div>
            </div>
          </Link>;
    })}
    </div>;
}
export default function The2026TechShop() {
  const wp_term_query_params = {
    taxonomy: "product_cat",
    per_page: 4,
    orderby: "count",
    order: "desc"
  };
  const wp_term_query = new WP_Term_Query(wp_term_query_params);
  return <section id="the-capsule-collections" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center md:mb-16">
          <h2 className="font-default text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl text-foreground">
            The Capsule Collections
          </h2>
          <p className="mt-4 max-w-2xl text-muted-foreground font-default text-lg md:text-xl">
            Fidget toys for your favorite obsessions. Tiny treasures, big serotonin, 
            designed with a touch of French pop flair.
          </p>
        </div>

        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <CategoryGrid />
        </EcommerceTermsProvider>
      </div>
    </section>;
}